// ─── Independence Day seasonal theme ──────────────────────────────────────────
// Every I-Day flourish on the site reads this one file. It auto-expires — after
// the window closes the theme turns itself off, no deploy needed.
//
//   Preview any time  →  ?iday=1
//   Force off         →  ?iday=0

// 14 Aug 2026 00:00 IST  →  17 Aug 2026 00:00 IST (IST = UTC+5:30)
const START = Date.UTC(2026, 7, 13, 18, 30);
const END   = Date.UTC(2026, 7, 16, 18, 30);

export const IDAY = {
  eyebrow:   "Independence Day 2026",
  yearsFree: 80,                             // 80th Independence Day (Govt. naming)
  saffron:   "#FF9933",
  green:     "#138808",
  navy:      "#000080",
};

export function isIndependenceWindow() {
  if (typeof window !== "undefined") {
    const q = new URLSearchParams(window.location.search).get("iday");
    if (q === "1") return true;
    if (q === "0") return false;
  }
  const now = Date.now();
  return now >= START && now < END;
}

export function prefersReducedMotion() {
  return typeof window !== "undefined"
    && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
}
